<template>
  <div class="boxInfo">
    <el-tabs
      type="border-card"
      style="height: 100%;"
      :value="'first'"
      @tab-click="handleTabClick"
    >
      <!--'新增分区'\'分区详情'-->
      <el-tab-pane
        :label="typeIndex === 1 ? $t('basicData.AddPartition') : $t('basicData.PartitionDetails')"
        name="first"
      >
        <div class="addFormBox">
          <el-form
            ref="queryForm"
            class="queryFormClass"
            :model="formData"
            :rules="rules"
            size="small"
            :label-width="$i18n.locale==='zh'?'120px':''"
            :label-position="$i18n.locale!=='zh'?'top':'right'"
          >
            <el-row>
              <el-col :span="20">
                <!--分区方案名称-->
                <el-form-item
                  :label="$t('basicData.PartitionSchemeName')"
                  prop="name"
                >
                  <el-input
                    v-model.trim="formData.name"
                    :placeholder="$t('orderDetails.pleaseInput')"
                    clearable
                    maxlength="40"
                    show-word-limit
                  />
                </el-form-item>
              </el-col>
              <el-col :span="20">
                <!--备注内容-->
                <el-form-item :label="$t('basicData.RemarkContent')">
                  <el-input
                    v-model="formData.remark"
                    :placeholder="$t('orderDetails.pleaseInput')"
                    type="textarea"
                    :rows="3"
                    maxlength="200"
                    show-word-limit
                  />
                </el-form-item>
              </el-col>
              <el-col :span="20">
                <!--业务类型-->
                <el-form-item
                  :label="$t('collectionCenter.businessT')"
                  prop="businessType"
                >
                  <el-select
                    v-model="formData.businessType"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  >
                    <el-option
                      v-for="item in P_BUSINESS_TYPE"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div class="feet-r mb10">
            <template v-if="typeIndex !== 3">
              <!--新增分区 "-->
              <el-button
                v-permit:remove="'btn:finance:basicData:payable:partition-add'"
                size="small"
                type="primary"
                @click="handleAdd"
              >
                {{ $t('basicData.AddPartition') }}
              </el-button>

              <el-popover
                placement="bottom-start"
                trigger="hover"
              >
                <import-download
                  :table-data="formData"
                  :all-state="allState"
                  :all-city="allCity"
                  @importPartition="importPartition"
                />
                <template #reference>
                  <el-button size="small" plain>
                    {{ $t('basicData.ImportDownload') }}
                  </el-button>
                </template>
              </el-popover>
            </template>

            <el-input
              v-model="searchCode"
              :placeholder="$t('basicData.zipCode')"
              size="small"
              clearable
              style="width: 350px"
              @clear="clearHighlight"
            >
              <template #prepend>
                {{ $t('basicData.zipCode') }}
              </template>
              <template #append>
                <el-button icon="el-icon-search" @click="handleSearch" />
              </template>
            </el-input>

            <el-button-group>
              <el-button
                :disabled="!hasSearchResults || currentHighlightIndex <= 0"
                size="small"
                icon="el-icon-arrow-left"
                @click="highlightPrev"
              >
                {{ $t('mdfeTranslate.Previous') }}
              </el-button>
              <el-button
                :disabled="!hasSearchResults"
                size="small"
                type="primary"
              >
                {{ currentHighlightIndex + 1 }}/{{ searchResults.length }}
              </el-button>
              <el-button
                :disabled="!hasSearchResults || currentHighlightIndex >= searchResults.length - 1"
                size="small"
                @click="highlightNext"
              >
                {{ $t('mdfeTranslate.Next') }}
                <i class="el-icon-arrow-right el-icon--right" />
              </el-button>
            </el-button-group>
          </div>
          <!--分区明细-->
          <el-form
            ref="tableForm"
            :model="formData"
            size="small"
            class="error-form"
            label-width="0px"
          >
            <virtual-scroll
              ref="virtualScroll"
              :key="key"
              :data="formData.partitionAffiliateList"
              :item-size="76"
              key-prop="key"
              @change="(virtualList) => list = virtualList"
            >
              <el-table
                ref="tableRef"
                :data="list"
                border
                row-key="key"
                :height="500"
                :row-class-name="getRowClassName"
                :highlight-current-row="false"
              >
                <virtual-column width="80" type="index" />

                <el-table-column :label="$t('basicData.PartitionName')" width="200">
                  <template #header>
                    <div>
                      <span style="color: red;">*</span>
                      <span>{{ $t('basicData.PartitionName') }}</span>
                    </div>
                  </template>
                  <template v-slot="scope">
                    <el-form-item
                      :prop="`partitionAffiliateList.${scope.$index}.partitionIdentifier`"
                      :rules="nameRules"
                    >
                      <el-input
                        v-model="scope.row.partitionIdentifier"
                        maxlength="50"
                        show-word-limit
                        :placeholder="$t('basicData.PartitionName')"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column :label="$t('GlobalSetObj.Estado')" width="240">
                  <template #header>
                    <div>
                      <span style="color: red;">*</span>
                      <span>{{ $t('GlobalSetObj.Estado') }}</span>
                    </div>
                  </template>
                  <template v-slot="scope">
                    <el-form-item
                      :prop="`partitionAffiliateList.${scope.$index}.state`"
                      :rules="getStateRules(scope.row)"
                    >
                      <el-select
                        v-model="scope.row.state"
                        multiple
                        clearable
                        filterable
                        collapse-tags
                        :placeholder="$t('GlobalSetObj.pleaseChoose')"
                        @change="changeState(scope)"
                      >
                        <el-option
                          v-for="item in scope.row.allState"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                          <span style="float: left">{{ item.label }}</span>
                          <span style="float: right; color: #8492a6; font-size: 13px">
                            {{ item.name }}
                          </span>
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column :label="$t('orderCenterCont.city')" width="180">
                  <template #header>
                    <div>
                      <span style="color: red;">*</span>
                      <span>{{ $t('orderCenterCont.city') }}</span>
                    </div>
                  </template>
                  <template v-slot="scope">
                    <el-form-item
                      :key="cityKey"
                      :prop="`partitionAffiliateList.${scope.$index}.city`"
                      :rules="getCityRules(scope.row)"
                    >
                      <ElSelectV2
                        v-model="scope.row.city"
                        multiple
                        clearable
                        filterable
                        collapse-tags
                        :options="scope.row.allCity"
                        :placeholder="$t('GlobalSetObj.pleaseChoose')"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column :label="$t('basicData.zipCode')">
                  <template #header>
                    <div>
                      <span style="color: red;">*</span>
                      <span>{{ $t('basicData.zipCode') }}</span>
                    </div>
                  </template>
                  <template v-slot="scope">
                    <el-form-item
                      :prop="`partitionAffiliateList.${scope.$index}.postalCode`"
                      :rules="getPostalCodeRules(scope.row)"
                    >
                      <el-input
                        v-model="scope.row.postalCode"
                        type="textarea"
                        :rows="2"
                        :placeholder="$t('basicData.ZipCodeExample')"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column :label="$t('basicData.operate')" width="100">
                  <template v-slot="scope">
                    <el-popconfirm
                      :title="$t('basicData.AreYouSureYouWantToDelete')"
                      @confirm="handleDel(scope)"
                    >
                      <!--删除-->
                      <template #reference>
                        <el-button type="danger" size="mini">
                          {{ $t('basicData.Delete') }}
                        </el-button>
                      </template>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
            </virtual-scroll>
          </el-form>
        </div>

        <div class="addFooter">
          <!--取消-->
          <el-button size="small" @click="handleCancel">
            {{ $t('basicData.Cancel') }}
          </el-button>
          <!--保存-->
          <el-button
            v-permit:remove="'btn:finance:basicData:payable:partition-edit'"
            size="small"
            type="primary"
            @click="submitForm"
          >
            {{ $t('basicData.Save') }}
          </el-button>
        </div>
      </el-tab-pane>

      <!--操作日志-->
      <el-tab-pane
        v-if="typeIndex === 2"
        :label="$t('basicData.OperationalLogs')"
        name="second"
      >
        <operation-log
          v-if="isSecondActive"
          :edit-data="editData"
        />
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      :title="$t('basicData.tips')"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="30%"
    >
      <div
        v-for="(item, ind) in errorMessages"
        :key="ind"
        style="color: red; margin-bottom: 10px;"
      >
        {{ item }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">
          {{ $t('basicData.determine') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { apiAffiliateAdd, apiAffiliateDelete, apiAffiliateEdit, apiGetAffiliateById } from '@/api/finance/partition';
import { apiAreaPage } from '@/api/finance/basicData';
import { postalCodeFormat, rowComparison } from '@/views/finance/basicData/partition/cmp/utils';
import { P_BUSINESS_TYPE } from '@/views/finance/enums.js';
import { Loading } from 'element-ui';
import VirtualScroll, { VirtualColumn } from 'el-table-virtual-scroll';
import ElSelectV2 from 'el-select-v2';
import { cloneDeep } from 'lodash-es';

const LOADING_OPTIONS = {
  lock: true,
  spinner: 'el-icon-loading',
  text: 'loading...',
  background: 'rgba(250, 250, 250, 0.6)'
};

export default {
  components: {
    VirtualScroll,
    VirtualColumn,
    ElSelectV2,
    'import-download': () => import('./ImportDownload'),
    'operation-log': () => import('./operationLog')
  },

  props: {
    // 类型标识 1新增 2编辑 3查看
    typeIndex: {
      type: Number,
      default: 1
    },
    // 编辑数据
    editData: {
      type: Object,
      default: () => ({})
    },
    // 所有州
    allState: {
      type: Array,
      default: () => []
    },
    // 所有城市
    allCity: {
      type: Array,
      default: () => []
    }
  },

  data() {
    const nameRules = {
      required: true,
      message: this.$t('basicData.CannotBeEmpty'),
      trigger: ['blur', 'change']
    };

    const postalCodeCheck = (rule, value, callback) => {
      if (!rule.required) {
        callback();
        return;
      }

      const [formatValid, formatError] = postalCodeFormat(value?.trim() || '');
      if (!formatValid) {
        callback(new Error(formatError));
        return;
      }

      const [comparisonValid, comparisonError] = rowComparison(value);
      if (!comparisonValid) {
        callback(new Error(comparisonError));
        return;
      }

      callback();
    };

    return {
      rules: {
        name: [
          { required: true, message: this.$t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] },
          {
            min: 2,
            max: 40,
            message: this.$i18n.t('basicData.TheLengthBetween2And40Characters'),
            trigger: ['blur', 'change']
          }
        ],
        businessType: {
          required: true,
          message: this.$i18n.t('basicData.CannotBeEmpty'),
          trigger: ['blur', 'change']
        }
      },
      nameRules,
      postalCodeCheck,
      P_BUSINESS_TYPE,
      list: [],
      key: Date.now(),
      errorMessages: [],
      dialogVisible: false,
      formData: {
        name: '',
        remark: '',
        businessType: '',
        partitionAffiliateList: []
      },
      cityKey: Date.now(),
      isSecondActive: false,
      searchCode: '',
      searchResults: [],
      currentHighlightIndex: -1
    };
  },

  computed: {
    hasSearchResults() {
      return this.searchResults.length > 0;
    },
    // 查看
    isViewMode() {
      return this.typeIndex === 3;
    },
    // 编辑
    isEditMode() {
      return this.typeIndex === 2;
    },
    // 新增
    isAddMode() {
      return this.typeIndex === 1;
    }
  },

  watch: {
    searchCode(newVal) {
      if (!newVal) {
        this.clearHighlight();
      } else {
        this.handleSearch();
      }
    },

    'formData.partitionAffiliateList.length'() {
      this.key = Date.now();
    }
  },

  created() {
    if (this.editData.id || this.editData.partitionId) {
      const id = this.isViewMode ? this.editData.partitionId : this.editData.id;
      this.fetchPartitionData(id);
    }
  },

  methods: {
    getStateRules(row) {
      return {
        required: !row.postalCode && row.city.length === 0,
        message: this.$t('basicData.CannotBeEmpty'),
        trigger: ['blur', 'change']
      };
    },

    getCityRules(row) {
      return {
        required: !row.postalCode && row.state.length === 0,
        message: this.$t('basicData.CannotBeEmpty'),
        trigger: ['blur', 'change']
      };
    },

    getPostalCodeRules(row) {
      return {
        required: row.city.length === 0 && row.state.length === 0,
        validator: this.postalCodeCheck,
        trigger: ['blur', 'change']
      };
    },

    handleTabClick(tab) {
      if (tab.name === 'second' && !this.isSecondActive) {
        this.isSecondActive = true;
      }
    },

    changeState(scope) {
      const { $index } = scope;
      const row = this.formData.partitionAffiliateList[$index];

      row.allCity = [];
      row.city = [];

      if (row.state.length === 0) {
        this.$set(row, 'allCity', this.allCity);
        this.cityKey = Date.now();
        return;
      }

      const params = {
        pageNumber: 1,
        pageSize: 99999,
        params: {
          level: 2,
          parentIdList: row.state
        }
      };

      apiAreaPage(params, false).then(res => {
        if (res.code === 200) {
          const cityList = (res.data.records || []).map(item => ({
            label: item.name,
            value: item.id,
            name: item.name
          }));
          this.$set(row, 'allCity', cityList);
          this.cityKey = Date.now();
        }
      });
    },

    handleAdd() {
      const newItem = {
        id: '',
        partitionIdentifier: '',
        postalCode: '',
        allState: this.allState,
        allCity: this.allCity,
        state: [],
        city: [],
        key: this.generateUniqueKey()
      };
      // 复制上一条数据
      if (this.formData.partitionAffiliateList.length > 0) {
        const row = cloneDeep(this.formData.partitionAffiliateList).pop();
        newItem.partitionIdentifier = row.partitionIdentifier;
        newItem.state = row.state;
      }
      this.formData.partitionAffiliateList.push(newItem);
      this.$refs.tableForm.clearValidate();
    },

    importPartition(arr) {
      const newItems = arr.map((item, index) => ({
        postalCode: item.zipcode,
        state: item.state && item.state.length > 0 ? item.state : [],
        allState: this.allState,
        allCity: item.allCity || this.allCity,
        city: item.city && item.city.length > 0 ? item.city : [],
        partitionIdentifier: item.name,
        id: item.id || '',
        key: this.generateUniqueKey(index)
      }));

      const hasIds = arr.some(item => item.id);
      if (hasIds) {
        this.formData.partitionAffiliateList = newItems;
      } else {
        this.formData.partitionAffiliateList = [...this.formData.partitionAffiliateList, ...newItems];
      }

      this.key = Date.now();
    },
    // 删除分区
    handleDel(scope) {
      const { row, $index } = scope;

      if (row.id) {
        apiAffiliateDelete(row.id).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('basicData.TheOperationSucceeded'));
          }
        });
      }

      this.formData.partitionAffiliateList.splice($index, 1);
    },
    // 取消
    handleCancel() {
      this.$emit('updatePage', false);
    },
    // form校验
    validateForm() {
      return new Promise((resolve) => {
        this.$refs.queryForm.validate((valid) => {
          if (!valid) {
            resolve(false);
            return;
          }

          if (this.formData.partitionAffiliateList.length === 0) {
            this.$message.warning(this.$t('basicData.PleaseAddPartitions'));
            resolve(false);
            return;
          }

          this.$refs.tableForm.validate((tabValid) => {
            resolve(tabValid);
          });
        });
      });
    },
    // 保存
    async submitForm() {
      const isValid = await this.validateForm();
      if (!isValid) return;

      const loadingInstance = Loading.service(LOADING_OPTIONS);

      try {
        this.errorMessages = [];
        // 验证邮编
        const zipCodeErrors = this.verifyZipCode(this.formData.partitionAffiliateList);
        this.processZipCodeErrors(zipCodeErrors);

        // 验证重复数据
        const duplicateErrors = this.checkDuplicates();
        this.processDuplicateErrors(duplicateErrors);

        if (this.errorMessages.length > 0) {
          this.dialogVisible = true;
          return;
        }

        await this.savePartitionData();

        this.$message.success(this.$t('basicData.TheOperationSucceeded'));
        this.$emit('updatePage', true);
      } catch (error) {
        console.error('Submit error:', error);
      } finally {
        loadingInstance.close();
      }
    },

    processZipCodeErrors(zipCodeErrors) {
      if (zipCodeErrors.errArr.length > 0) {
        this.errorMessages.push(...zipCodeErrors.errArr);
      }
      if (zipCodeErrors.repeat.length > 0) {
        this.errorMessages.push(...zipCodeErrors.repeat);
      }
    },

    processDuplicateErrors(duplicates) {
      const { name, zipCode, city, state } = duplicates;

      if (name.length > 1) {
        const tip = this.$i18n.t('basicData.Lines') + name.join(',') + this.$i18n.t('basicData.repeat');
        this.errorMessages.push(tip);
      }

      if (zipCode.length > 1) {
        const tip = this.$i18n.t('basicData.Lines') + zipCode.join(',') + this.$i18n.t('basicData.areDuplicated');
        this.errorMessages.push(tip);
      }

      if (city.length > 1) {
        const tip = this.$i18n.t('basicData.Lines') + city.join(',') + this.$i18n.t('basicData.theCityIsDuplicated');
        this.errorMessages.push(tip);
      }

      if (state.length > 1) {
        const tip = this.$i18n.t('basicData.Lines') + state.join(',') + this.$i18n.t('basicData.StateDuplication');
        this.errorMessages.push(tip);
      }
    },

    checkDuplicates() {
      const duplicates = {
        name: [],
        zipCode: [],
        city: [],
        state: []
      };

      const list = this.formData.partitionAffiliateList;

      list.forEach((item, i) => {
        // 检查分区名称重复
        const hasSameName = list.some((other, j) =>
          j !== i && other.partitionIdentifier === item.partitionIdentifier
        );
        if (hasSameName && !duplicates.name.includes(i + 1)) {
          duplicates.name.push(i + 1);
        }

        // 检查邮编重复
        const hasSameZip = list.some((other, j) =>
          j !== i &&
          other.postalCode &&
          item.postalCode &&
          other.postalCode === item.postalCode
        );
        if (hasSameZip && !duplicates.zipCode.includes(i + 1)) {
          duplicates.zipCode.push(i + 1);
        }

        // 检查城市重复
        if (!item.postalCode && item.city.length > 0) {
          const hasSameCity = list.some((other, j) =>
            j !== i &&
            !other.postalCode &&
            other.city.length > 0 &&
            this.haveIntersection(item.city, other.city)
          );
          if (hasSameCity && !duplicates.city.includes(i + 1)) {
            duplicates.city.push(i + 1);
          }
        }

        // 检查州重复
        if (!item.postalCode && item.city.length === 0 && item.state.length > 0) {
          const hasSameState = list.some((other, j) =>
            j !== i &&
            !other.postalCode &&
            other.city.length === 0 &&
            other.state.length > 0 &&
            this.haveIntersection(item.state, other.state)
          );
          if (hasSameState && !duplicates.state.includes(i + 1)) {
            duplicates.state.push(i + 1);
          }
        }
      });

      return duplicates;
    },

    haveIntersection(arr1, arr2) {
      return arr1.some(item => arr2.includes(item));
    },

    verifyZipCode(arr) {
      const errors = {
        errArr: [],
        repeat: []
      };

      arr.forEach((item, index) => {
        if (!item.state?.length && !item.city?.length && !item.postalCode) {
          errors.errArr.push(`${index + 1}：${this.$t('basicData.StateCityZipCodeLeastOneRequired')}`);
        }

        const zipCode = this.normalizePostalCode(item.postalCode);
        if (!zipCode) return;

        if (!this.isValidPostalCodeFormat(zipCode)) {
          errors.errArr.push(`${index + 1}：${this.$t('basicData.areMalformed')}`);
          return;
        }

        const parts = this.parsePostalCodeParts(zipCode);
        if (!this.validatePostalCodeParts(parts)) {
          errors.errArr.push(`${index + 1}：${this.$t('basicData.areMalformed')}`);
        }
      });

      if (errors.errArr.length > 0) return errors;

      for (let i = 0; i < arr.length; i++) {
        const zipA = this.normalizePostalCode(arr[i].postalCode);
        if (!zipA) continue;

        const partsA = this.parsePostalCodeParts(zipA);

        // 检查内部重复
        for (let j = 0; j < partsA.length; j++) {
          for (let k = j + 1; k < partsA.length; k++) {
            if (!this.comparePostalCodeIntervals(partsA[j], partsA[k])) {
              errors.repeat.push(`${this.$t('basicData.row')}${i + 1}${this.$t('basicData.line')}:${partsA[j]} and ${this.$t('basicData.row')}${i + 1}${this.$t('basicData.line')}:${partsA[k]}${this.$t('basicData.IntervalsOverlap')}`);
              return errors;
            }
          }
        }

        // 检查行间重复
        for (let j = i + 1; j < arr.length; j++) {
          const zipB = this.normalizePostalCode(arr[j].postalCode);
          if (!zipB) continue;

          const partsB = this.parsePostalCodeParts(zipB);

          for (const partA of partsA) {
            for (const partB of partsB) {
              if (!this.comparePostalCodeIntervals(partA, partB)) {
                errors.repeat.push(`${this.$t('basicData.row')}${i + 1}${this.$t('basicData.line')}:${partA} and ${this.$t('basicData.row')}${j + 1}${this.$t('basicData.line')}:${partB}${this.$t('basicData.intersect')}`);
                return errors;
              }
            }
          }
        }
      }

      return errors;
    },

    normalizePostalCode(postalCode) {
      if (!postalCode) return '';
      return postalCode.trim().replace(/，/ig, ',');
    },

    isValidPostalCodeFormat(zipCode) {
      const parts = zipCode.split(',').filter(part => part.trim());
      return !parts.includes('');
    },

    parsePostalCodeParts(zipCode) {
      return zipCode.split(',').map(part => part.trim()).filter(part => part);
    },

    validatePostalCodeParts(parts) {
      return parts.every(part => {
        if (part.includes('~')) {
          const range = part.split('~').map(num => num.trim());
          if (range.length !== 2 || range.includes('')) return false;

          const [start, end] = range.map(Number);
          if (isNaN(start) || isNaN(end) || start >= end) return false;

          return /^[A-Z0-9 \-]+$/g.test(range[0]) && /^[A-Z0-9 \-]+$/g.test(range[1]);
        } else {
          return /^[A-Z0-9 \-]+$/g.test(part) && /\d/.test(part);
        }
      });
    },

    comparePostalCodeIntervals(intervalA, intervalB) {
      if (!intervalA || !intervalB) return true;

      const parseInterval = (interval) => {
        if (interval.includes('~')) {
          const [start, end] = interval.split('~').map(Number);
          return { type: 'range', start, end };
        } else {
          return { type: 'single', value: Number(interval) };
        }
      };

      const a = parseInterval(intervalA);
      const b = parseInterval(intervalB);

      if (a.type === 'single' && b.type === 'single') {
        return a.value !== b.value;
      }

      if (a.type === 'range' && b.type === 'range') {
        return a.end < b.start || b.end < a.start;
      }

      if (a.type === 'single' && b.type === 'range') {
        return a.value < b.start || a.value > b.end;
      }

      if (a.type === 'range' && b.type === 'single') {
        return b.value < a.start || b.value > a.end;
      }

      return true;
    },

    // 格式化提交数据
    formatSubmitData() {
      return this.formData.partitionAffiliateList.map(item => ({
        partitionIdentifier: item.partitionIdentifier,
        postalCode: item.postalCode,
        id: item.id,
        state: item.state?.join(',') || '',
        city: item.city?.join(',') || '',
        partitionId: this.editData.id
      }));
    },
    // 保存分区数据
    async savePartitionData() {
      const submitData = this.formatSubmitData();
      const payload = {
        id: this.isEditMode ? this.editData.id : '',
        name: this.formData.name,
        businessType: this.formData.businessType,
        remark: this.formData.remark,
        attribute: 2,
        partitionAffiliateList: submitData
      };

      if (this.isAddMode) {
        // 新增
        await apiAffiliateAdd(payload);
      } else if (this.isEditMode) {
        // 修改
        await apiAffiliateEdit(payload);
      }
    },
    // 获取分区详情
    async fetchPartitionData(id) {
      const res = await apiGetAffiliateById(id);
      if (res.code !== 200) return;

      const { businessType, name, remark, partitionAffiliateList } = res.data;

      this.formData = { businessType, name, remark, partitionAffiliateList: [] };

      await Promise.all(partitionAffiliateList.map(async(item, index) => {
        const processedItem = this.processPartitionItem(item, index);
        this.formData.partitionAffiliateList.push(processedItem);

        if (item.state) {
          await this.fetchCityData(item.state, index);
        }
      }));
    },
    processPartitionItem(item, index) {
      const processed = {
        ...item,
        allState: this.allState,
        allCity: this.allCity,
        key: this.generateUniqueKey(index)
      };

      if (typeof item.city === 'string' && item.city.trim()) {
        try {
          processed.city = item.city.split(',').map(Number).filter(Boolean);
        } catch {
          processed.city = [];
        }
      } else {
        processed.city = [];
      }

      if (typeof item.state === 'string' && item.state.trim()) {
        try {
          processed.state = item.state.split(',').filter(Boolean);
        } catch {
          processed.state = [];
        }
      } else {
        processed.state = [];
      }

      return processed;
    },

    async fetchCityData(stateList, index) {
      if (!stateList?.length) return;

      const params = {
        pageNumber: 1,
        pageSize: 99999,
        params: {
          level: 2,
          parentIdList: Array.isArray(stateList) ? stateList : stateList.split(',').map(Number)
        }
      };

      const res = await apiAreaPage(params);
      if (res.code === 200) {
        this.$set(
          this.formData.partitionAffiliateList[index],
          'allCity',
          (res.data.records || []).map(item => ({
            label: item.name,
            value: item.id,
            name: item.name
          }))
        );
        this.cityKey = Date.now();
      }
    },

    generateUniqueKey(index = 0) {
      return `item-${Date.now()}-${index}-${Math.random().toString(36).substr(2, 9)}`;
    },
    // 搜索处理
    handleSearch() {
      const searchTerm = this.searchCode.trim();
      if (!searchTerm) {
        this.clearHighlight();
        return;
      }

      const results = this.formData.partitionAffiliateList
        .map((row, index) => ({ row, index }))
        .filter(item => {
          const { postalCode } = item.row;
          const postalCodeList = this.parseDataRanges(postalCode);
          console.log('postalCodeList', postalCodeList);
          const {
            matched,
            matchedRange
          } = this.postalCodeFormat(searchTerm, postalCodeList);
          console.log('matched', matched, matchedRange);
          return matched;
        });

      this.searchResults = results;
      this.currentHighlightIndex = results.length ? 0 : -1;

      if (results.length > 0) {
        this.$nextTick(() => this.scrollToHighlightedRow());
      }
    },
    // 下一个
    highlightNext() {
      if (!this.hasSearchResults) return;
      this.currentHighlightIndex = (this.currentHighlightIndex + 1) % this.searchResults.length;
      this.$nextTick(() => this.scrollToHighlightedRow());
    },
    // 上一个
    highlightPrev() {
      if (!this.hasSearchResults) return;
      this.currentHighlightIndex =
        this.currentHighlightIndex <= 0
          ? this.searchResults.length - 1
          : this.currentHighlightIndex - 1;
      this.$nextTick(() => this.scrollToHighlightedRow());
    },
    // 滚动到当前高亮行
    scrollToHighlightedRow() {
      // 获取表格的虚拟滚动实例
      const virtualScroll = this.$refs.virtualScroll.$el;

      if (this.currentHighlightIndex < 0) return;

      const currentMatch = this.searchResults[this.currentHighlightIndex];
      if (!currentMatch) return;

      const rowIndex = currentMatch.index;

      const rowHeight = 76; // 每行的预计高度，根据实际情况调整
      const viewportHeight = virtualScroll.clientHeight; // 可视区域高度
      // const totalRows = this.formData.partitionAffiliateList.length; // 表格总行数
      const maxRowsInViewport = Math.floor(viewportHeight / rowHeight); // 可视区域最多能显示的行数
      const startIndex = Math.max(0, rowIndex - Math.floor(maxRowsInViewport / 2)); // 计算开始滚动的行索引
      const scrollTop = rowHeight * startIndex; // 计算需要滚动的位置
      console.log('scrollTop', scrollTop, startIndex);
      this.setScrollTop(scrollTop);

      // 强制表格重新渲染以应用高亮样式
      this.$nextTick(() => {
        if (this.$refs.virtualScroll && this.$refs.virtualScroll.doLayout) {
          this.$refs.virtualScroll.doLayout();
        }
      });
    },
    // 清空搜索
    clearHighlight() {
      this.searchCode = '';
      this.searchResults = [];
      this.currentHighlightIndex = -1;
      this.$nextTick(() => {
        this.setScrollTop();
      });
    },
    // 设置滚动距离
    setScrollTop(top = 0) {
      const tableRef = this.$refs.tableRef.$el.querySelector('.el-table__body-wrapper'); // 表格元素
      tableRef.scrollTo({
        top: top,
        behavior: 'smooth'
      });
    },
    // 获取行样式
    getRowClassName({ row, rowIndex }) {
      return this.isRowHighlighted(row, rowIndex) ? 'highlighted-row' : '';
    },
    // 检查行是否高亮
    isRowHighlighted(row, rowIndex) {
      if (this.currentHighlightIndex < 0) return false;

      const currentResult = this.searchResults[this.currentHighlightIndex];
      return currentResult && currentResult.row.key === row.key;
    },
    // 邮编匹配规则
    postalCodeFormat(value, parsedRanges) {
      const number = parseFloat(value);

      let matched = false;
      let matchedRange = null;

      for (const range of parsedRanges) {
        if (range.type === 'single') {
          if (range.value.includes(number)) {
            matched = true;
            matchedRange = range;
            break;
          }
        } else if (range.type === 'range') {
          if (number >= range.start && number <= range.end) {
            matched = true;
            matchedRange = range;
            break;
          }
        }
      }
      return {
        matched,
        matchedRange
      };
    },
    // 邮编解析
    parseDataRanges(code) {
      const ranges = [];
      const parts = code.split(',');

      for (const part of parts) {
        const trimmedPart = part.trim();

        if (trimmedPart.includes('~')) {
          // 处理区间
          const [start, end] = trimmedPart.split('~').map(num => parseFloat(num.trim()));
          if (!isNaN(start) && !isNaN(end)) {
            ranges.push({ type: 'range', start, end });
          }
        } else {
          // 处理单个数字
          const num = parseFloat(trimmedPart);
          if (!isNaN(num)) {
            ranges.push({ type: 'single', value: num.toString() });
          }
        }
      }

      return ranges;
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep {
  .highlighted-row,
  .highlighted-row:hover > td {
    background-color: #e6f7ff !important;
  }

  .highlighted-row {
    position: relative;

    &::after {
      position: absolute;
      content: '';
      width: 5px;
      height: 100%;
      background-color: #00A551;
      left: 0;
    }
  }
}

.boxInfo {
  height: 100%;

  ::v-deep .el-tabs__content {
    padding: 0;

    .el-tab-pane {
      height: 100%;

      .addFormBox {
        height: calc(100vh - 96px);
        padding: 15px;
        overflow-y: auto;
      }
    }
  }

  .addFooter {
    border-top: 1px solid #ccc;
    padding: 10px;
    text-align: right;
  }
}
</style>
